<template>
  <transition name="fade">
    <div v-if="visible" class="dialog-mask" @click.self="handleClose">
      <transition name="zoom">
        <div class="dialog-box" v-show="visible" :style="{ width, borderRadius }">
          <div class="dialog-content">
            <div style="color: #403636;font-weight: bolder;font-size: 32px;">选择发布岗位的类型</div>
            <a class="offlinejob" @click="gotoOfflineJob()">
              <div style="display: flex;flex-direction: column;">
                <div class="jobtop">需线下面试</div>
                <div style="display: flex;align-items: center;margin-top: 10px;">
                  <div class="jobmiddle">本地岗位</div>
                  <img class="arrow" src="https://www.mgadmob.com/mp/icon/ic_right_black_arrow_small.png"/>
                </div>
              </div>
              <img src="https://www.mgadmob.com/mp/icon/ic_offline_review.png"
                   style="margin-left: auto;width: 100px;height: 100px;"/>
            </a>
            <a class="offlinejob" style="background-image: url('https://www.mgadmob.com/mp/icon/ic_online_bg.png');margin-top: 20px;"
                  @click="gotoOnlineJob()">
              <div style="display: flex;flex-direction: column;">
                <div class="jobtop">按量计费</div>
                <div style="display: flex;align-items: center;margin-top: 10px;">
                  <div class="jobmiddle">线上岗位</div>
                  <img class="arrow" src="https://www.mgadmob.com/mp/icon/ic_right_black_arrow_small.png"></img>
                </div>
                <div class="jobbottom">适用于全网全国不限地区招聘</div>
              </div>
              <img src="https://www.mgadmob.com/mp/icon/ic_online_review.png" style="margin-left: auto;width: 100px;height: 100px;"></img>
            </a>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ChoosePostJobTypeDialog',
  props: {
    visible: {type: Boolean, default: false},
    type: {type: String, default: 'text'}, // image / text / custom
    image: {type: String, default: ''},
    title: {type: String, default: ''},
    message: {type: String, default: ''},
    width: {type: String, default: '360px'},
    borderRadius: {type: String, default: '14px'},
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    gotoOfflineJob() {
      this.$emit('gotoOfflineJob')
      this.handleClose()
    },
    gotoOnlineJob() {
      this.$emit('gotoOnlineJob')
      this.handleClose()
    }
  }
}
</script>

<style scoped>
/* 遮罩层，百分百占满视口，高度必须 100vh */
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* 弹窗主体 */
.dialog-box {
  background: linear-gradient(to bottom, #DDFDFA, #FBFDEE);
  padding: 12px;
  max-width: 80vw;
  width: auto;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  text-align: center;
  /* 💡 防止动画偏移 */
  transform-origin: center;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 20px;
}


/* ✅ 动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.zoom-enter-active, .zoom-leave-active {
  transition: all 0.25s cubic-bezier(0.3, 0.8, 0.3, 1.2);
}

.zoom-enter, .zoom-leave-to {
  transform: scale(0.85);
  opacity: 0;
}

.offlinejob {
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 20px;
  text-align: left;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("https://www.mgadmob.com/mp/icon/ic_offline_bg.png");
  margin-top: 25px;
  padding: 17px 18px 17px 18px;
}

.jobmiddle {
  font-size: 25px;
  color: #000000;
  font-weight: bold;
}

.jobtop {
  font-size: 18px;
  color: #21D4A4;
}

.arrow {
  width: 10px;
  height: 15px;
  margin-left: 27px;
}

.jobbottom {
  font-size: 18rpx;
  color: #747474;
}
</style>
